import { OnboardingConfigDTO, OnboardingModuleEnum } from "front-lib";

export const vehicleTypesOnboarding: OnboardingConfigDTO = {
    module: OnboardingModuleEnum.SETTINGS_VEHICLE_TYPES,
    steps: [
        {
            id: "vt-welcome",
            title: "Tipos de Veículo",
            description:
                "Defina os tipos de veículo aceitos na plataforma e vincule cada um a uma ou mais categorias.",
            position: "center",
        },
        {
            id: "vt-list",
            title: "Lista de Tipos",
            description:
                "Veja os tipos cadastrados com nome, ícone e categorias vinculadas. Clique para editar.",
            targetId: "vehicle-types-list",
            position: "bottom",
        },
        {
            id: "vt-add",
            title: "Adicionar Tipo",
            description:
                "Crie um novo tipo de veículo (ex: Sedan, SUV, Moto) e vincule às categorias disponíveis.",
            targetId: "vehicle-types-add-btn",
            position: "left",
        },
        {
            id: "vt-mode",
            title: "Modo de Transporte",
            description:
                "Cada tipo pode ter um modo de transporte (carro, moto, bicicleta) que define o ícone mostrado nos apps.",
            position: "center",
        },
    ],
};
